namespace GeniuzPOS.PosShift {
    export namespace PosTranHdService {
        export const baseUrl = 'PosShift/PosTranHd';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PosTranHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PosTranHdRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "PosShift/PosTranHd/Retrieve",
            List = "PosShift/PosTranHd/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PosTranHdService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
